// Action Types
export const actionTypes = {
  //maintained value
  GET_MAINTAINED_VALUES: "GET_MAINTAINED_VALUES",
  GET_MAINTAINED_VALUES_SUCCESS: "GET_MAINTAINED_VALUES_SUCCESS",
  GET_MAINTAINED_VALUES_FAILED: "GET_MAINTAINED_VALUES_FAILED",
  //search spouse
  SPOUSE_FOR_SEARCH: "SPOUSE_FOR_SEARCH",
  SPOUSE_FOR_SEARCH_SUCCESS: "SPOUSE_FOR_SEARCH_SUCCESS",
  SPOUSE_FOR_SEARCH_FAILED: "SPOUSE_FOR_SEARCH_FAILED",
  //search co buyer
  CO_BUYER_FOR_SEARCH: "CO_BUYER_FOR_SEARCH",
  CO_BUYER_FOR_SEARCH_SUCCESS: "CO_BUYER_FOR_SEARCH_SUCCESS",
  CO_BUYER_FOR_SEARCH_FAILED: "CO_BUYER_FOR_SEARCH_FAILED",
  //search group
  GROUP_FOR_SEARCH: "GROUP_FOR_SEARCH",
  GROUP_FOR_SEARCH_SUCCESS: "GROUP_FOR_SEARCH_SUCCESS",
  GROUP_FOR_SEARCH_FAILED: "GROUP_FOR_SEARCH_FAILED",
  //post buyer
  POST_BUYER: "POST_BUYER",
  POST_BUYER_SUCCESS: "POST_BUYER_SUCCESS",
  POST_BUYER_FAILED: "POST_BUYER_FAILED",
  //post spouse
  POST_SPOUSE: "POST_SPOUSE",
  POST_SPOUSE_SUCCESS: "POST_SPOUSE_SUCCESS",
  POST_SPOUSE_FAILED: "POST_SPOUSE_FAILED",
  //post co buyer
  POST_CO_BUYER: "POST_CO_BUYER",
  POST_CO_BUYER_SUCCESS: "POST_CO_BUYER_SUCCESS",
  POST_CO_BUYER_FAILED: "POST_CO_BUYER_FAILED",
  //CIS Requirements
  POST_CIS_REQUIREMENTS: "POST_CIS_REQUIREMENTS",
  POST_CIS_REQUIREMENTS_SUCCESS: "POST_CIS_REQUIREMENTS_SUCCESS",
  POST_CIS_REQUIREMENTS_FAILED: "POST_CIS_REQUIREMENTS_FAILED",
  //CPRA Requirements
  POST_CPRA_REQUIREMENTS: "POST_CPRA_REQUIREMENTS",
  POST_CPRA_REQUIREMENTS_SUCCESS: "POST_CPRA_REQUIREMENTS_SUCCESS",
  POST_CPRA_REQUIREMENTS_FAILED: "POST_CPRA_REQUIREMENTS_FAILED",
  //Purchase Journey
  POST_PURCHASE_JOURNEY: "POST_PURCHASE_JOURNEY",
  POST_PURCHASE_JOURNEY_SUCCESS: "POST_PURCHASE_JOURNEY_SUCCESS",
  POST_PURCHASE_JOURNEY_FAILED: "POST_PURCHASE_JOURNEY_FAILED",
  //get reservation details
  GET_RESERVATION_DETAIL: "GET_RESERVATION_DETAIL",
  GET_RESERVATION_DETAIL_SUCCESS: "GET_RESERVATION_DETAIL_SUCCESS",
  GET_RESERVATION_DETAIL_FAILED: "GET_RESERVATION_DETAIL_FAILED",
  //
  GET_RESERVATION_LIST_FROM_SAP: "GET_RESERVATION_LIST_FROM_SAP",
  GET_RESERVATION_LIST_FROM_SAP_SUCCESS:
    "GET_RESERVATION_LIST_FROM_SAP_SUCCESS",
  GET_RESERVATION_LIST_FROM_SAP_FAILED: "GET_RESERVATION_LIST_FROM_SAP_FAILED",
  //post to sap
  POST_TO_SAP: "POST_TO_SAP",
  POST_TO_SAP_SUCCESS: "POST_TO_SAP_SUCCESS",
  POST_TO_SAP_FAILED: "POST_TO_SAP_FAILED",
  //get draft user
  GET_DRAFT_USER: "GET_DRAFT_USER",
  GET_DRAFT_USER_SUCCESS: "GET_DRAFT_USER_SUCCESS",
  GET_DRAFT_USER_FAILED: "GET_DRAFT_USER_FAILED",
  //submit to sap
  SUBMIT_TO_SAP: "SUBMIT_TO_SAP",
  SUBMIT_TO_SAP_SUCCESS: "SUBMIT_TO_SAP_SUCCESS",
  SUBMIT_TO_SAP_FAILED: "SUBMIT_TO_SAP_FAILED",

  //update attachment
  UPDATE_ATTACHMENT: "UPDATE_ATTACHMENT",
  UPDATE_ATTACHMENT_SUCCESS: "UPDATE_ATTACHMENT_SUCCESS",
  UPDATE_ATTACHMENT_FAILED: "UPDATE_ATTACHMENT_FAILED",

  //update cis info
  UPDATE_CIS_INFO : "UPDATE_CIS_INFO",
  UPDATE_CIS_INFO_SUCCESS : "UPDATE_CIS_INFO_SUCCESS",
  UPDATE_CIS_INFO_FAILED : "UPDATE_CIS_INFO_FAILED"
};

// Action creators
export const actionCreators = {
  //update cis info
  updateCisInfo: (params) => ({
    type: actionTypes.UPDATE_CIS_INFO,
    params,
  }),
  //update attachment
  updateAttachment: (params) => ({
    type: actionTypes.UPDATE_ATTACHMENT,
    params,
  }),
  getMaintainedValues: (params) => ({
    type: actionTypes.GET_MAINTAINED_VALUES,
    params,
  }),
  searchForSpouse: (params) => ({
    type: actionTypes.SPOUSE_FOR_SEARCH,
    params,
  }),
  searchForCoBuyer: (params) => ({
    type: actionTypes.CO_BUYER_FOR_SEARCH,
    params,
  }),
  searchForGroup: (params) => ({
    type: actionTypes.GROUP_FOR_SEARCH,
    params,
  }),
  postForBuyer: (params) => ({
    type: actionTypes.POST_BUYER,
    params,
  }),
  //spouse
  postForSpouse: (params) => ({
    type: actionTypes.POST_SPOUSE,
    params,
  }),
  //co buyer
  postForCoBuyer: (params) => ({
    type: actionTypes.POST_CO_BUYER,
    params,
  }),
  //cis requirements
  postForCISRequirements: (params) => ({
    type: actionTypes.POST_CIS_REQUIREMENTS,
    params,
  }),
  //CPRA requirements
  postForCPRARequirements: (params) => ({
    type: actionTypes.POST_CPRA_REQUIREMENTS,
    params,
  }),
  //purchase journey
  postForPurchaseJourney: (params) => ({
    type: actionTypes.POST_PURCHASE_JOURNEY,
    params,
  }),
  //get reservation details
  getReservationDetails: (params) => ({
    type: actionTypes.GET_RESERVATION_DETAIL,
    params,
  }),
  //get reservation list from spa
  getReservationListFromSap: (params) => ({
    type: actionTypes.GET_RESERVATION_LIST_FROM_SAP,
    params,
  }),
  //get draft user
  getDraftUser: (params) => ({
    type: actionTypes.GET_DRAFT_USER,
    params,
  }),
  //submit to sap
  submitToSap: (params) => ({
    type: actionTypes.SUBMIT_TO_SAP,
    params,
  }),
};

// Reducer
const initialState = {
  //cis info update
  isUpdatingCis: false,
  updatedCis: [],

  titles: [],
  countries: [],
  regions: [],
  civilStatus: [],
  occupations: [],
  positions: [],
  suffixes: [],
  brokerRoles: [],
  salesGroups: [],
  brokerTypes: [],
  agentStatus: [],
  inputTaxCodes: [],
  iTextGroups: [],
  banks: [],
  currencies: [],
  isLoading: false,
  error: null,
  result: null,
  marketResult: [],
  //post
  postSpouseResult: [],
  postCoBuyerResult: [],
  isPostingSpouse: false,
  isPostingCoBuyer: false,
  //search
  spouseResult: [],
  coBuyerResult: [],
  groupResult: [],
  isSearchingSpouse: false,
  isSearchingCoBuyer: false,
  isSearchingGroup: false,
  //buyer
  buyerResult: [],
  isPostBuyerSearching: false,
  isDonePostBuyer: false,
  isDonePostCoBuyer: false,
  isDonePostSpouse: false,
  //cis requirements
  cisRequirementsResult: [],
  isPostingCISRequirements: false,
  //cpra requirements
  cpraRequirementsResult: [],
  isPostingCPRARequirements: false,
  //purchase journey
  purchaseJourneyResult: [],
  isPostingPurchaseJourney: false,
  //reservation details
  reservationDetails: [],
  //reservation list from sap
  getReservationListFromSap: [],
  isGettingReservation: false,
  //draft user
  draftUserResult: [],
  submitSapResult: [],
  isPostingToSap: false,
  updateAttachmentResult: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    //update cis info
    case actionTypes.UPDATE_CIS_INFO:
      return Object.assign({}, state, {
        error: null,
        updatedCis: [],
        isUpdatingCis: true
      });
    case actionTypes.UPDATE_CIS_INFO_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        updatedCis: action.payload,
        isUpdatingCis: false
      });
    case actionTypes.UPDATE_CIS_INFO_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isUpdatingCis: false
      });
    //update attachment
    case actionTypes.UPDATE_ATTACHMENT:
      return Object.assign({}, state, {
        error: null,
        updateAttachmentResult: [],
      });
    case actionTypes.UPDATE_ATTACHMENT_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        updateAttachmentResult: action.payload,
      });
    case actionTypes.UPDATE_ATTACHMENT_FAILED:
      return Object.assign({}, state, {
        error: action.error,
      });
    //submit to sap
    case actionTypes.SUBMIT_TO_SAP:
      return Object.assign({}, state, {
        error: null,
        submitSapResult: [],
        isPostingToSap: true,
      });
    case actionTypes.SUBMIT_TO_SAP_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        submitSapResult: action.payload,
        isPostingToSap: false,
      });
    case actionTypes.SUBMIT_TO_SAP_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isPostingToSap: false,
      });
    //get draft user
    case actionTypes.GET_DRAFT_USER:
      return Object.assign({}, state, {
        error: null,
        draftUserResult: [],
      });
    case actionTypes.GET_DRAFT_USER_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        draftUserResult: action.payload,
      });
    case actionTypes.GET_DRAFT_USER_FAILED:
      return Object.assign({}, state, {
        error: action.error,
      });
    //get reservation list from sap
    case actionTypes.GET_RESERVATION_LIST_FROM_SAP:
      return Object.assign({}, state, {
        error: null,
        getReservationListFromSap: [],
        isGettingReservation: true,
      });
    case actionTypes.GET_RESERVATION_LIST_FROM_SAP_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        getReservationListFromSap: action.payload,
        isGettingReservation: false,
      });
    case actionTypes.GET_RESERVATION_LIST_FROM_SAP_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isGettingReservation: false,
      });
    //posting of spouse
    case actionTypes.POST_SPOUSE:
      return Object.assign({}, state, {
        error: null,
        postSpouseResult: [],
        isPostingSpouse: true,
        isDonePostSpouse: false
      });
    case actionTypes.POST_SPOUSE_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        postSpouseResult: action.payload,
        isPostingSpouse: false,
        isDonePostSpouse: true
      });
    case actionTypes.POST_SPOUSE_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isPostingSpouse: false,
        isDonePostSpouse: true
      });
    //posting of co buyer
    case actionTypes.POST_CO_BUYER:
      return Object.assign({}, state, {
        error: null,
        postCoBuyerResult: [],
        isPostingCoBuyer: true,
        isDonePostCoBuyer: false
      });
    case actionTypes.POST_CO_BUYER_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        postCoBuyerResult: action.payload,
        isPostingCoBuyer: false,
        isDonePostCoBuyer: true
      });
    case actionTypes.POST_CO_BUYER_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isDonePostCoBuyer: false,
        isPostingCoBuyer: true,
      });
    //searching of group
    case actionTypes.GROUP_FOR_SEARCH:
      return Object.assign({}, state, {
        error: null,
        groupResult: [],
        isSearchingGroup: true,
      });
    case actionTypes.GROUP_FOR_SEARCH_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        groupResult: action.payload,
        isSearchingGroup: false,
      });
    case actionTypes.GROUP_FOR_SEARCH_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isSearchingGroup: false,
      });
    //searching of spouse
    case actionTypes.SPOUSE_FOR_SEARCH:
      return Object.assign({}, state, {
        error: null,
        spouseResult: [],
        isSearchingSpouse: true,
      });
    case actionTypes.SPOUSE_FOR_SEARCH_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        spouseResult: action.payload,
        isSearchingSpouse: false,
      });
    case actionTypes.SPOUSE_FOR_SEARCH_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isSearchingSpouse: false,
      });
    //searching of co buyer
    case actionTypes.CO_BUYER_FOR_SEARCH:
      return Object.assign({}, state, {
        error: null,
        coBuyerResult: [],
        isSearchingCoBuyer: true,
      });
    case actionTypes.CO_BUYER_FOR_SEARCH_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        coBuyerResult: action.payload,
        isSearchingCoBuyer: false,
      });
    case actionTypes.CO_BUYER_FOR_SEARCH_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isSearchingCoBuyer: false,
      });
    //posting of buyer
    case actionTypes.POST_BUYER:
      return Object.assign({}, state, {
        error: null,
        buyerResult: [],
        isPostBuyerSearching: true,
        isDonePostBuyer: false,
      });
    case actionTypes.POST_BUYER_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        buyerResult: action.payload,
        isPostBuyerSearching: false,
        isDonePostBuyer: true,
      });
    case actionTypes.POST_BUYER_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isPostBuyerSearching: false,
        isDonePostBuyer: true,
      });
    //posting of CIS Requirements
    case actionTypes.POST_CIS_REQUIREMENTS:
      return Object.assign({}, state, {
        error: null,
        cisRequirementsResult: [],
        isPostingCISRequirements: true,
      });
    case actionTypes.POST_CIS_REQUIREMENTS_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        cisRequirementsResult: action.payload,
        isPostingCISRequirements: false,
      });
    case actionTypes.POST_CIS_REQUIREMENTS_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isPostingCISRequirements: false,
      });
    //posting of CPRA Requirements
    case actionTypes.POST_CPRA_REQUIREMENTS:
      return Object.assign({}, state, {
        error: null,
        cpraRequirementsResult: [],
        isPostingCPRARequirements: true,
      });
    case actionTypes.POST_CPRA_REQUIREMENTS_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        cpraRequirementsResult: action.payload,
        isPostingCPRARequirements: false,
      });
    case actionTypes.POST_CPRA_REQUIREMENTS_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isPostingCPRARequirements: false,
      });
    //purchase journey
    case actionTypes.POST_PURCHASE_JOURNEY:
      return Object.assign({}, state, {
        error: null,
        purchaseJourneyResult: [],
        isPostingPurchaseJourney: true,
      });
    case actionTypes.POST_PURCHASE_JOURNEY_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        purchaseJourneyResult: action.payload,
        isPostingPurchaseJourney: false,
      });
    case actionTypes.POST_PURCHASE_JOURNEY_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isPostingPurchaseJourney: false,
      });
    //get reservation details
    case actionTypes.GET_RESERVATION_DETAIL:
      return Object.assign({}, state, {
        error: null,
        reservationDetails: null,
      });

    case actionTypes.GET_RESERVATION_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        reservationDetails: action.payload,
      });

    case actionTypes.GET_RESERVATION_DETAIL_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        reservationDetails: null,
      });

    //maintained values
    case actionTypes.GET_MAINTAINED_VALUES:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
      });

    case actionTypes.GET_MAINTAINED_VALUES_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        titles: action.payload.titles,
        countries: action.payload.countries,
        regions: action.payload.regions,
        civilStatus: action.payload.civil_statuses,
        occupations: action.payload.occupations,
        positions: action.payload.positions,
        suffixes: action.payload.suffixes,
        brokerRoles: action.payload.broker_roles,
        salesGroups: action.payload.sales_group,
        brokerTypes: action.payload.broker_types,
        agentStatus: action.payload.agent_statuses,
        inputTaxCodes: action.payload.input_tax_codes,
        iTextGroups: action.payload.i_text_groups,
        banks: action.payload.banks,
        currencies: action.payload.currencies,
      });

    case actionTypes.GET_MAINTAINED_VALUES_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        // marketingPartners: []
      });

    default:
      return state;
  }
};
